/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { EnumerationOptionDto } from './EnumerationOptionDto';
import {
    EnumerationOptionDtoFromJSON,
    EnumerationOptionDtoFromJSONTyped,
    EnumerationOptionDtoToJSON,
} from './EnumerationOptionDto';
import type { EvaluationState } from './EvaluationState';
import {
    EvaluationStateFromJSON,
    EvaluationStateFromJSONTyped,
    EvaluationStateToJSON,
} from './EvaluationState';

/**
 * 
 * @export
 * @interface EnumerationDataPointDto
 */
export interface EnumerationDataPointDto {
    /**
     * 
     * @type {string}
     * @memberof EnumerationDataPointDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof EnumerationDataPointDto
     */
    readonly creationTime: string;
    /**
     * 
     * @type {string}
     * @memberof EnumerationDataPointDto
     */
    creatorUserFullName?: string | null;
    /**
     * 
     * @type {EvaluationState}
     * @memberof EnumerationDataPointDto
     */
    evaluationOutcome: EvaluationState;
    /**
     * 
     * @type {number}
     * @memberof EnumerationDataPointDto
     */
    commentCount?: number | null;
    /**
     * 
     * @type {string}
     * @memberof EnumerationDataPointDto
     */
    lastComment?: string | null;
    /**
     * 
     * @type {number}
     * @memberof EnumerationDataPointDto
     */
    commentAttachmentsCount?: number | null;
    /**
     * 
     * @type {EnumerationOptionDto}
     * @memberof EnumerationDataPointDto
     */
    selectedOption: EnumerationOptionDto;
    /**
     * 
     * @type {string}
     * @memberof EnumerationDataPointDto
     */
    $type?: EnumerationDataPointDtoTypeEnum;
}


/**
 * @export
 */
export const EnumerationDataPointDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedResultsDtoEnumerationDataPointDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.Results.Dto.EnumerationDataPointDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type EnumerationDataPointDtoTypeEnum = typeof EnumerationDataPointDtoTypeEnum[keyof typeof EnumerationDataPointDtoTypeEnum];



/**
 * Check if a given object implements the EnumerationDataPointDto interface.
 */
export function instanceOfEnumerationDataPointDto(value?: unknown): value is EnumerationDataPointDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(EnumerationDataPointDtoTypeEnum)[0];
}

export function EnumerationDataPointDtoFromJSON(json: any): EnumerationDataPointDto {
    return EnumerationDataPointDtoFromJSONTyped(json, false);
}

export function EnumerationDataPointDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): EnumerationDataPointDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'creationTime': json['creationTime'],
        'creatorUserFullName': json['creatorUserFullName'] == null ? undefined : json['creatorUserFullName'],
        'evaluationOutcome': EvaluationStateFromJSON(json['evaluationOutcome']),
        'commentCount': json['commentCount'] == null ? undefined : json['commentCount'],
        'lastComment': json['lastComment'] == null ? undefined : json['lastComment'],
        'commentAttachmentsCount': json['commentAttachmentsCount'] == null ? undefined : json['commentAttachmentsCount'],
        'selectedOption': EnumerationOptionDtoFromJSON(json['selectedOption']),
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function EnumerationDataPointDtoToJSON(value?: Omit<EnumerationDataPointDto, 'creationTime'> | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'id': value['id'],
        'creatorUserFullName': value['creatorUserFullName'],
        'evaluationOutcome': EvaluationStateToJSON(value['evaluationOutcome']),
        'commentCount': value['commentCount'],
        'lastComment': value['lastComment'],
        'commentAttachmentsCount': value['commentAttachmentsCount'],
        'selectedOption': EnumerationOptionDtoToJSON(value['selectedOption']),
        '$type': value['$type'],
    });
}

